// ★U8(cmd-po_1109): sip-stepper共通部品 — catalog #24 機械転写
// DOM構造=component_dom_contract.md sip-stepper区画契約準拠
import React from "react";
import Box from "@mui/material/Box";
import CheckIcon from "@mui/icons-material/Check";

interface SipStepperProps {
  /** ステップのラベル配列（順番に表示） */
  steps: string[];
  /** 現在アクティブなステップのインデックス（0始まり）。これより小さいインデックスはdone */
  activeIndex: number;
  /** ステッパー末尾に追加する要素（例：担当者バッジ） */
  suffix?: React.ReactNode;
}

/**
 * sip-stepper共通部品 — 作成系ウィザードのステップ進行表示
 * catalog #24: .sip-stepper / .step-item / .step-dot / .step-rule の機械転写
 */
export function SipStepper({ steps, activeIndex, suffix }: SipStepperProps) {
  return (
    <Box
      data-testid="sip-stepper"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "var(--sp-2, 8px)",
        px: "var(--sp-5, 20px)",
        py: "var(--sp-3, 12px)",
        borderBottom: "1px solid var(--color-border-light, #efefea)",
        flexShrink: 0,
        background: "var(--color-washi, #fafaf8)",
      }}
    >
      {steps.map((label, i) => {
        const isDone = i < activeIndex;
        const isActive = i === activeIndex;
        return (
          <React.Fragment key={label}>
            {i > 0 && (
              <Box
                component="span"
                sx={{
                  flex: "0 0 28px",
                  height: "1.5px",
                  background: "var(--color-border, #e5e5e0)",
                  display: "inline-block",
                }}
              />
            )}
            <Box
              component="span"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: "var(--sp-2, 8px)",
                fontSize: "var(--fs-12, 12px)",
                color: isActive
                  ? "var(--color-sumi, #374151)"
                  : "var(--color-sumi-muted, #9ca3af)",
                fontWeight: isActive ? "var(--fw-bold, 700)" : 400,
                "@media (max-width: 639px)": { whiteSpace: "nowrap" },
              }}
            >
              <Box
                component="span"
                sx={{
                  width: 22,
                  height: 22,
                  borderRadius: "50%",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "var(--fs-11, 11px)",
                  fontWeight: "var(--fw-bold, 700)",
                  flexShrink: 0,
                  background: isDone
                    ? "var(--color-ai-pale, #e8eef4)"
                    : isActive
                    ? "var(--color-ai, #1e3a5f)"
                    : "var(--color-white, #ffffff)",
                  border: isDone
                    ? "1.5px solid var(--color-ai, #1e3a5f)"
                    : isActive
                    ? "1.5px solid var(--color-ai, #1e3a5f)"
                    : "1.5px solid var(--color-border, #e5e5e0)",
                  color: isDone
                    ? "var(--color-ai, #1e3a5f)"
                    : isActive
                    ? "var(--color-white, #ffffff)"
                    : "var(--color-sumi-muted, #9ca3af)",
                }}
              >
                {isDone ? <CheckIcon sx={{ fontSize: 11 }} /> : i + 1}
              </Box>
              <Box
                component="span"
                data-testid="step-label"
                sx={{
                  "@media (max-width: 639px)": {
                    display: isActive ? undefined : "none",
                  },
                }}
              >
                {label}
              </Box>
            </Box>
          </React.Fragment>
        );
      })}
      {suffix !== undefined && (
        <Box sx={{ ml: "auto" }}>{suffix}</Box>
      )}
    </Box>
  );
}
